import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HedgingViewComponent } from './hedging-view/hedging-view.component';
import { GroupingViewComponent } from './grouping-view/grouping-view.component';
import { SharedModule } from 'src/app/modules/shared.module';
import { RouterModule } from '@angular/router';
import { DateInQuarterPipe } from 'src/app/pipes/quarter-date.pipe';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CoverProposalDialog } from './hedging-view/cover-proposal-dialog/cover-proposal-dialog.component';
import { CdkDrag, CdkDropList, CdkDropListGroup, CdkDragPlaceholder } from "@angular/cdk/drag-drop";
import { CoverDialogComponent } from './hedging-view/cover-dialog/cover-dialog.component';
import { IndexedPriceFormulaInfoComponent } from './hedging-view/indexed-price-formula-info/indexed-price-formula-info.component';
import { OverlayModule } from '@angular/cdk/overlay';

@NgModule({
    declarations: [HedgingViewComponent, GroupingViewComponent, DateInQuarterPipe, CoverProposalDialog, CoverDialogComponent, IndexedPriceFormulaInfoComponent ],
    imports: [CommonModule, MatCheckboxModule, SharedModule, RouterModule, CdkDrag, CdkDropList, CdkDropListGroup, CdkDragPlaceholder, OverlayModule],
    exports: [],
    providers: [],
})
export class GroupingsModule {}